import React from 'react';
import "../CSS/WorkersComp.css";
import workersCompHero from '../Images/solutions/Workers_ Compensation/solution-workers_-compensation.png';
import workersCompHeroMob from '../Images/Mobile Images/solutions/Workers_ Compensation/solution-workers_-compensation-image-mobile.png';
import workersCompDivider from '../Images/solutions/Workers_ Compensation/workers-compensation-divider-image.png';
import workersCompDividerMob from '../Images/Mobile Images/solutions/Workers_ Compensation/workers-compensation-divider-image-mobile.png';
import peopleIcon from "../Images/services/people-icon.svg";
import processIcon from "../Images/services/process-icon.svg";
import resultsIcon from "../Images/services/results-icon.svg";
import { Link } from 'react-router-dom';

const WorkersComp: React.FC = () => {
  return (
    <div>
      <div className="workers-comp-hero">
        <div className="workers-comp-hero-img" style={{ '--hero-bg': `url(${workersCompHero})`, '--hero-bg-mob': `url(${workersCompHeroMob})`, backgroundImage: `url(${workersCompHero})` } as React.CSSProperties}>
          <div className="workers-comp-hero-content">
            <div className="workers-comp-hero-subtitle">Workers' Compensation</div>
            <div className="workers-comp-hero-title">Faster Claims. Better Care.</div>
            <div className="workers-comp-hero-desc">
              Remote clinical teams accelerate claim processing while maintaining exceptional quality—at a significantly lower cost.
            </div>
          </div>
        </div>
      </div>

      <div className="hq-clinical-operations">
        <div className="hq-clinical-operations-left">
          <div className="hq-clinical-operations-title">High-Quality Support Services to Drive Accurate Clinical Operations</div>
          <Link to="/contact-us" className="hq-clinical-operations-btn">Contact Us</Link>
        </div>
        <div className="hq-clinical-operations-right">
          <div className="hq-clinical-operations-grid">
            <div className="hq-clinical-operations-card">
              <div className="hq-clinical-operations-card-title">Nurse Triage</div>
              <div className="hq-clinical-operations-card-desc">Flexibility in schedules, offering a 24/7 solution for nurse triage coverage, with consistent quality results</div>
            </div>
            <div className="hq-clinical-operations-card">
              <div className="hq-clinical-operations-card-title">Network Management</div>
              <div className="hq-clinical-operations-card-desc">Ensuring provider credentialing and panel card creation for full compliance across all states, both mandatory and non-mandatory.</div>
            </div>
            <div className="hq-clinical-operations-card">
              <div className="hq-clinical-operations-card-title">Document Management</div>
              <div className="hq-clinical-operations-card-desc">We offer indexing, sorting, and bookmarking services for a variety of areas</div>
            </div>
            <div className="hq-clinical-operations-card">
              <div className="hq-clinical-operations-card-title">Peer Review Preparation & Quality Assurance</div>
              <div className="hq-clinical-operations-card-desc">20% cost reduction in utilizing a clinical team to prep peer review reports for U.S. clinicians</div>
            </div>
            <div className="hq-clinical-operations-card">
              <div className="hq-clinical-operations-card-title">Utilization Review</div>
              <div className="hq-clinical-operations-card-desc">Experts in the Utilization Review process with millions of cases processed every year</div>
            </div>
            <div className="hq-clinical-operations-card">
              <div className="hq-clinical-operations-card-title">Bill Review</div>
              <div className="hq-clinical-operations-card-desc">Millions of provider, facility, and reconsideration bills are reviewed annually to ensure the services provided are accurate based on state guidelines</div>
            </div>
            <div className="hq-clinical-operations-card">
              <div className="hq-clinical-operations-card-title">Network Management</div>
              <div className="hq-clinical-operations-card-desc">Provider validation and creation of panel cards for all mandatory and non-mandatory state</div>
            </div>
            <div className="hq-clinical-operations-card">
              <div className="hq-clinical-operations-card-title">Pharmacy Reviews</div>
              <div className="hq-clinical-operations-card-desc">Medication and prior authorization review of medication requests at the point of sale before the pharmacy dispenses the medication</div>
            </div>
            <div className="hq-clinical-operations-card">
              <div className="hq-clinical-operations-card-title">Customer Service</div>
              <div className="hq-clinical-operations-card-desc">We provide customer service support to callers regarding medical bill status, PPO reimbursements, fee schedules, and appeals</div>
            </div>
            <div className="hq-clinical-operations-card">
              <div className="hq-clinical-operations-card-title">Case Management Support</div>
              <div className="hq-clinical-operations-card-desc">Support case managers in return to work efforts for injured workers, providing administrative and clinical support functions such as intake, prep, and QA</div>
            </div>
          </div>
        </div>
      </div>

      <div className="workers-comp-statistics">
        <div className="workers-comp-statistics-heading">
          Quality Isn't Just a Metric—It's a Mission. <b>Medwell360 Delivers Nothing Less.</b>
        </div>
        <div className="workers-comp-statistics-row">
          <div className="workers-comp-statistics-item">
            <div className="workers-comp-statistics-value">1M+</div>
            <div className="workers-comp-statistics-label">Utilization Review Cases Closed / Year</div>
          </div>
          <div className="workers-comp-statistics-item">
            <div className="workers-comp-statistics-value">~45%</div>
            <div className="workers-comp-statistics-label">Cost Savings</div>
          </div>
          <div className="workers-comp-statistics-item">
            <div className="workers-comp-statistics-value">330K</div>
            <div className="workers-comp-statistics-label">Quality Audits/ Year</div>
          </div>
          <div className="workers-comp-statistics-item">
            <div className="workers-comp-statistics-value">99.9%</div>
            <div className="workers-comp-statistics-label">Quality Audit Score</div>
          </div>
          <div className="workers-comp-statistics-item">
            <div className="workers-comp-statistics-value">5M+</div>
            <div className="workers-comp-statistics-label">Cases Handled/ Year</div>
          </div>
        </div>
      </div>

      <div className="health-care-challenges-desc">
        <h2 className="health-care-challenges-title">Understand Today's Healthcare Challenges</h2>
        <div className="health-care-challenges-cards">
          <div className="health-care-challenges-card">
            <div className="health-care-challenges-card-title">Staffing Gaps Impact Care Quality</div>
            <div className="health-care-challenges-card-desc">Persistent clinical shortages hinder timely access to treatment and support—directly affecting patient outcomes.</div>
          </div>
          <div className="health-care-challenges-card">
            <div className="health-care-challenges-card-title">Operational Strain on Claims Functions</div>
            <div className="health-care-challenges-card-desc">High volumes, administrative overload, and delays in service approvals place growing pressure on claims teams and jeopardize care continuity.</div>
          </div>
          <div className="health-care-challenges-card">
            <div className="health-care-challenges-card-title">Rising Costs of Skilled Talent</div>
            <div className="health-care-challenges-card-desc">The difficulty in hiring and retaining qualified professionals often leads to reliance on underqualified staff—escalating risk and lowering care standards.</div>
          </div>
        </div>
      </div>

      <div className="workers-comp-divider">
        <picture>
          <source media="(max-width: 1100px)" srcSet={workersCompDividerMob} />
          <img
            src={workersCompDivider}
            alt="Workers Comp Divider"
            className="workers-comp-divider-img"
          />
        </picture>
      </div>

      <div className="workers-comp-outcomes">
        <h2 className="workers-comp-outcomes-title">Partner with Us to Deliver Scalable, High-Quality Clinical Outcomes</h2>
        <div className="workers-comp-outcomes-cards">
          <div className="workers-comp-outcomes-card">
            <span className="workers-comp-outcomes-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1vw', width: '48px', height: '48px' }}>
              <img src={peopleIcon} alt="People Icon" style={{ width: '48px', height: '48px' }} />
            </span>
            <div className="workers-comp-outcomes-card-title">People</div>
            <ul className="workers-comp-outcomes-list">
              <li>Clinicians licensed in both the <b>Philippines (RN)</b> and the <b>U.S. (USRN</b>)</li>
              <li>Talent pool spans the <b>full clinical spectrum</b>, from frontline specialists to seasoned leadership</li>
              <li><b>300+ dedicated professionals</b> supporting Utilization Management (UM) and Utilization Review (UR) functions</li>
            </ul>
          </div>
          <div className="workers-comp-outcomes-card">
            <span className="workers-comp-outcomes-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1vw', width: '48px', height: '48px' }}>
              <img src={processIcon} alt="Process Icon" style={{ width: '48px', height: '48px' }} />
            </span>
            <div className="workers-comp-outcomes-card-title">Process</div>
            <ul className="workers-comp-outcomes-list">
              <li>Expertise across <b>25+ healthcare IT platforms</b>, including leading UM/UR systems</li>
              <li>Scalable support for both <b>short-term surges and long-term engagements</b></li>
              <li><b>HITRUST and SOC 1 & 2 certified</b> operations for data security and compliance</li>
              <li>Continuous improvement driven by <b>Lean and Six Sigma-certified teams</b></li>
              <li>Specialized capabilities to <b>optimize Workers' Compensation Utilization Management</b></li>
            </ul>
          </div>
          <div className="workers-comp-outcomes-card">
            <span className="workers-comp-outcomes-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1vw', width: '48px', height: '48px' }}>
              <img src={resultsIcon} alt="Results Icon" style={{ width: '48px', height: '48px' }} />
            </span>
            <div className="workers-comp-outcomes-card-title">Results</div>
            <ul className="workers-comp-outcomes-list">
              <li><b>Accelerated claims processing</b>, reducing turnaround times</li>
              <li>Achieved a <b>99.9% Quality Audit Score</b> across client engagements</li>
              <li>Delivered <b>45–60% cost savings</b> in labor and operations</li>
              <li>Successfully manage <b>over 5 million cases annually</b> with consistency and scale</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkersComp; 